import { useEffect } from 'react'

import { Navigate, useLocation } from 'react-router-dom'
import { APP_ROUTES } from 'shared/constants/routes'
import { SessionStorageKey } from 'shared/constants/sessionStorage'

import { ProtectedRouteProps } from './ProtectedRoute.types'

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  isLoggedIn
}) => {
  const location = useLocation()
  sessionStorage.removeItem(SessionStorageKey.HAS_CUSTOM_LOGIN_REDIRECT)

  useEffect(() => {
    if (!isLoggedIn) {
      const redirectUrl = `${location.pathname}${location.search}${
        location.hash
      }`
      sessionStorage.setItem(SessionStorageKey.POST_LOGIN_REDIRECT, redirectUrl)
    }
  }, [isLoggedIn, location.pathname, location.search, location.hash])

  if (!isLoggedIn) {
    return <Navigate to={APP_ROUTES.login.path} replace />
  }

  return <>{children}</>
}
